var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ScaleScreen",
    { staticClass: "scale-wrap", attrs: { width: 1920, height: 1080 } },
    [
      _c(
        "div",
        {
          staticStyle: {
            "background-repeat": "no-repeat",
            padding: "16px 16px 10px 16px",
            width: "100%",
            height: "100%",
            "font-size": "22px",
          },
          style: { backgroundImage: "url(" + _vm.login_bgs + ")" },
        },
        [
          _vm.showLoading
            ? _c("dv-loading", [_vm._v("Loading...")])
            : _c(
                "div",
                {
                  staticClass: "d-flex jc-center title_wrap",
                  staticStyle: { display: "flex", "justify-content": "center" },
                },
                [
                  _c("div", { staticClass: "zuojuxing" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "youjuxing" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "guang" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "d-flex jc-center",
                      staticStyle: {
                        display: "flex",
                        "justify-content": "center",
                      },
                    },
                    [
                      _c("div", { staticClass: "title" }, [
                        _c("span", { staticClass: "title-text" }, [
                          _vm._v("大屏可视化数据统计"),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "timers" }, [
                    _vm._v(
                      _vm._s(_vm.dateYear) +
                        " " +
                        _vm._s(_vm.dateWeek) +
                        " " +
                        _vm._s(_vm.dateDay)
                    ),
                  ]),
                ]
              ),
          _vm._v(" "),
          _c("div", { staticClass: "content-top" }, [
            _c(
              "div",
              { staticClass: "content-top-left" },
              [
                _c(
                  "dv-border-box-13",
                  {
                    staticClass: "content-item",
                    staticStyle: { "margin-bottom": "30px" },
                  },
                  [
                    _c("div", { staticClass: "content-title" }, [
                      _c("div", { staticClass: "left" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "content-title-text" }, [
                        _vm._v("今日统计数据"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "right" }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "info-data container",
                        staticStyle: { "background-color": "unset" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "items",
                            staticStyle: {
                              "background-color": "rgba(19, 25, 47, 0.6)",
                              color: "#fff",
                            },
                          },
                          [
                            _c(
                              "span",
                              { staticStyle: { "margin-bottom": "10px" } },
                              [_vm._v("租借中订单数")]
                            ),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.day_data.renting_order_num)),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "items",
                            staticStyle: {
                              "background-color": "rgba(19, 25, 47, 0.6)",
                              color: "#fff",
                            },
                          },
                          [
                            _c(
                              "span",
                              { staticStyle: { "margin-bottom": "10px" } },
                              [_vm._v("订单数")]
                            ),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.day_data.today_order_num)),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "items",
                            staticStyle: {
                              "background-color": "rgba(19, 25, 47, 0.6)",
                              color: "#fff",
                            },
                          },
                          [
                            _c(
                              "span",
                              { staticStyle: { "margin-bottom": "10px" } },
                              [_vm._v("已完成订单数")]
                            ),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.day_data.today_finish_order_num)
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "items",
                            staticStyle: {
                              "background-color": "rgba(19, 25, 47, 0.6)",
                              color: "#fff",
                            },
                          },
                          [
                            _c(
                              "span",
                              { staticStyle: { "margin-bottom": "10px" } },
                              [_vm._v("租借中订单金额")]
                            ),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.day_data.renting_order_amount)),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "items",
                            staticStyle: {
                              "background-color": "rgba(19, 25, 47, 0.6)",
                              color: "#fff",
                            },
                          },
                          [
                            _c(
                              "span",
                              { staticStyle: { "margin-bottom": "10px" } },
                              [_vm._v("订单金额")]
                            ),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.day_data.today_order_amount)),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "items",
                            staticStyle: {
                              "background-color": "rgba(19, 25, 47, 0.6)",
                              color: "#fff",
                            },
                          },
                          [
                            _c(
                              "span",
                              { staticStyle: { "margin-bottom": "10px" } },
                              [_vm._v("已完成订单金额")]
                            ),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.day_data.today_finish_order_amount)
                              ),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "dv-border-box-13",
                  { staticClass: "content-item" },
                  [
                    _c("div", { staticClass: "content-title" }, [
                      _c("div", { staticClass: "left" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "content-title-text" }, [
                        _vm._v("设备订单数据"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "right" }),
                    ]),
                    _vm._v(" "),
                    _c("dv-scroll-board", {
                      staticClass: "container",
                      attrs: { config: _vm.agent_info },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content-top-center" },
              [
                _c(
                  "dv-border-box-13",
                  {
                    staticClass: "content-item",
                    staticStyle: { height: "620px", width: "700px" },
                  },
                  [
                    _c("div", {
                      ref: "map_info",
                      staticStyle: { height: "620px", width: "700px" },
                      attrs: { id: "map_info" },
                    }),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content-top-right" },
              [
                _c(
                  "dv-border-box-13",
                  {
                    staticClass: "content-item",
                    staticStyle: { "margin-bottom": "30px" },
                  },
                  [
                    _c("div", { staticClass: "content-title" }, [
                      _c("div", { staticClass: "left" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "content-title-text" }, [
                        _vm._v("月统计数据"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "right" }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "info-data container",
                        staticStyle: { "background-color": "unset" },
                      },
                      _vm._l(_vm.info_data, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: "info_" + index,
                            staticClass: "items",
                            staticStyle: {
                              "background-color": "rgba(19, 25, 47, 0.6)",
                              color: "#fff",
                            },
                          },
                          [
                            _c(
                              "span",
                              { staticStyle: { "margin-bottom": "10px" } },
                              [_vm._v(_vm._s(item.name))]
                            ),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(item.value))]),
                          ]
                        )
                      }),
                      0
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "dv-border-box-13",
                  { staticClass: "content-item" },
                  [
                    _c("div", { staticClass: "content-title" }, [
                      _c("div", { staticClass: "left" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "content-title-text" }, [
                        _vm._v("商户排行榜"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "right" }),
                    ]),
                    _vm._v(" "),
                    _c("dv-scroll-ranking-board", {
                      staticClass: "container",
                      attrs: { config: _vm.store_order_rank },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "content-bottom",
              staticStyle: { "margin-top": "20px" },
            },
            [
              _c(
                "dv-border-box-13",
                { staticClass: "content-item bottom-content" },
                [
                  _c("div", { staticClass: "content-title" }, [
                    _c("div", { staticClass: "left" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "content-title-text" }, [
                      _vm._v("每日订单收入"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "right" }),
                  ]),
                  _vm._v(" "),
                  _c("dv-capsule-chart", {
                    staticClass: "container",
                    staticStyle: { "font-size": "20px" },
                    attrs: { config: _vm.paymant_data },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "dv-border-box-13",
                {
                  staticClass: "content-item",
                  staticStyle: { "flex-shrink": "0" },
                },
                [
                  _c("div", { staticClass: "content-title" }, [
                    _c("div", { staticClass: "left" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "content-title-text" }, [
                      _vm._v("统计数据"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "right" }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "info-data container",
                      staticStyle: {
                        "background-color": "unset",
                        "grid-template-columns": "1fr 1fr",
                        "font-size": "20px",
                      },
                    },
                    _vm._l(_vm.device_data, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: "device_" + index,
                          staticClass: "items",
                          staticStyle: {
                            "background-color": "rgba(19, 25, 47, 0.6)",
                            color: "#fff",
                          },
                        },
                        [
                          _c(
                            "span",
                            { staticStyle: { "margin-bottom": "10px" } },
                            [_vm._v(_vm._s(item.name))]
                          ),
                          _vm._v(" "),
                          _c("dv-digital-flop", {
                            staticStyle: { height: "50px", width: "100%" },
                            attrs: { config: item.config },
                          }),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "dv-border-box-13",
                { staticClass: "content-item bottom-content" },
                [
                  _c("div", { staticClass: "content-title" }, [
                    _c("div", { staticClass: "left" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "content-title-text" }, [
                      _vm._v("每日新增设备数"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "right" }),
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    ref: "refund_info",
                    staticClass: "container",
                    attrs: { id: "refund_info" },
                  }),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }